<template>
  <div v-if="item">
    <b-row class="mx-3 py-3">
      <b-col cols="12" md="6" class="my-1">
        <label
          >{{ item.startDate | moment($formatDate) }} -
          {{ item.endDate | moment($formatDate) }}</label
        >
      </b-col>
      <b-col cols="12" md="6" class="d-flex justify-content-end">
        <b-button
          class="menuactive p-0"
          @click="$emit('onNavigate', item.id, gotoTab[0][0], gotoTab[0][0])"
          variant="link"
        >
          {{ $t("showOrderDetails") }}
        </b-button>
      </b-col>
      <b-col cols="12"><hr class="mb-0" /></b-col>
    </b-row>
    <b-row class="mx-3">
      <b-col>
        <label class="my-1">{{ $t("totalSales") }}</label>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <label class="my-1"
          >฿ {{ item.orderResultDisplay.totalSales | numeral("0,0.00") }}</label
        >
      </b-col>
    </b-row>
    <b-row class="mx-3">
      <b-col>
        <label class="my-1">{{ $t("totalDiscount") }}</label>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <label class="my-1"
          >฿
          {{ item.orderResultDisplay.totalDiscount | numeral("0,0.00") }}</label
        >
      </b-col>
    </b-row>
    <b-row class="mx-3 pb-3">
      <b-col>
        <label class="my-1">{{ $t("salesAfterDiscount") }}</label>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <label class="my-1"
          >฿
          {{
            item.orderResultDisplay.totalSalesAfterDiscount | numeral("0,0.00")
          }}</label
        >
      </b-col>
      <b-col cols="12"><hr class="mb-0" /></b-col>
    </b-row>
    <b-row class="mx-3">
      <b-col>
        <label class="my-1"
          >{{ $t("salesFee") }} {{ $t("legalEntity") }}</label
        >
      </b-col>
      <b-col class="d-flex justify-content-end">
        <label class="my-1">฿ {{ item.orderResultDisplay.sellerFeeSellerGetfin | numeral("0,0.00") }}</label>
      </b-col>
    </b-row>
    <b-row class="mx-3 pb-3">
      <b-col>
        <label class="my-1"
          >{{ $t("salesFee") }} {{ $t("legalEntity") }} ({{
            $t("VATIncluded")
          }})</label
        >
      </b-col>
      <b-col class="d-flex justify-content-end">
        <label class="my-1">฿ {{ item.orderResultDisplay.sellerFeeSellerGetfinVat | numeral("0,0.00") }}</label>
      </b-col>
      <b-col cols="12"><hr class="mb-0" /></b-col>
    </b-row>
    <b-row class="mx-3">
      <b-col class="font-weight-bold">{{ $t("salesFee") }}</b-col>
      <b-col class="d-flex justify-content-end">
        <label
          >฿ {{ item.orderResultDisplay.sellerFee | numeral("0,0.00") }}</label
        >
      </b-col>
    </b-row>
    <b-row class="mx-3 pb-2">
      <b-col class="font-weight-bold"
        >{{ $t("expenses") }} ({{ $t("VATNotIncluded") }})</b-col
      >
    </b-row>
    <b-row class="mx-3">
      <b-col>
        <b-row>
          <b-col>
            <label>- {{ $t("platformAdministrationFee") }}</label>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <label
              >฿
              {{ item.orderResultDisplay.getfinFee | numeral("0,0.00") }}</label
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>- {{ $t("paymentTransactionFee") }}</label>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <label
              >฿
              {{
                item.orderResultDisplay.paymentFee | numeral("0,0.00")
              }}</label
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>- {{ $t("shippingFees") }}</label>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <label
              >฿
              {{
                item.orderResultDisplay.shippingFee | numeral("0,0.00")
              }}</label
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>- {{ $t("CODFees") }}</label>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <label
              >฿ {{ item.orderResultDisplay.codFee | numeral("0,0.00") }}</label
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>- {{ $t("additionalCostFromTransportation") }}</label>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <label
              >฿ {{ item.orderResultDisplay.shipjungCharge | numeral("0,0.00") }}</label
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>- {{ $t("getfinService") }}</label>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <label
              >฿
              {{
                item.orderResultDisplay.withdrawFee | numeral("0,0.00")
              }}</label
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>- {{ $t("totalService") }}</label>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <label
              >฿
              {{
                item.orderResultDisplay.totalService | numeral("0,0.00")
              }}</label
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>- {{ $t("totalServiceVat") }}</label>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <label
              >฿
              {{
                item.orderResultDisplay.totalServiceVat | numeral("0,0.00")
              }}</label
            >
          </b-col>
        </b-row>
        <!-- <b-row>
            <b-col>
                <label>- {{ $t("totalServiceVat") }}</label>
            </b-col>
            <b-col class="d-flex justify-content-end">
                <label
                >฿
                {{
                    item.orderResultDisplay.totalServiceVat | numeral("0,0.00")
                }}</label
                >
            </b-col>
        </b-row> -->
        <b-row v-if="item.refundOrders.length > 0">
          <b-col>
            <label>{{ $t("outstandingBalance") }}</label
            ><span
              class="ml-2 text-underline pointer"
              @click="$emit('onNavigate', item.id, gotoTab[1][0], gotoTab[1][1])"
              >{{ $t("details") }}</span
            >
          </b-col>
          <b-col class="d-flex justify-content-end">
            <label class="m-0"
              >฿
              {{
                item.orderResultDisplay.overdueTotal | numeral("0,0.00")
              }}</label
            >
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12"><hr class="mb-0" /></b-col>
    </b-row>
    <b-row class="mx-3 pt-3 collapse-statement-label-custom">
      <b-col cols="8">
        <label class="mb-1 w-100">{{
          $t("TotalAfterDeductionExpenses")
        }}</label>
      </b-col>
      <b-col cols="4" class="d-flex justify-content-end pl-0">
        <label
          >฿
          {{
            item.orderResultDisplay.grandTotalNotVat | numeral("0,0.00")
          }}</label
        >
      </b-col>
    </b-row>
    <b-row class="mx-3 collapse-statement-label-custom">
      <b-col class="d-flex">
        <label class="mb-1">{{ $t("withholdingTax") }}</label>
        <div :id="`tooltip-collapse-${indexTab}-${index}-1`">
          <b-button
            size="sm"
            variant="link"
            v-b-tooltip.hover
            class="tootip-custom"
          >
            <font-awesome-icon icon="question-circle" title="View" />
          </b-button>
        </div>
        <b-popover
          :target="`tooltip-collapse-${indexTab}-${index}-1`"
          triggers="hover"
          placement="right"
        >
          <template v-slot:default><TaxTooltip /></template>
        </b-popover>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <label
          >฿ {{ item.orderResultDisplay.whtTotal | numeral("0,0.00") }}</label
        >
      </b-col>
    </b-row>
    <b-row class="mx-3 collapse-statement-label-custom">
      <b-col class="d-flex">
        <label class="mb-1">{{ $t("transferAmount") }}</label>
        <div :id="`tooltip-collapse-${indexTab}-${index}-2`">
          <b-button
            size="sm"
            variant="link"
            v-b-tooltip.hover
            class="tootip-custom"
          >
            <font-awesome-icon icon="question-circle" title="View" />
          </b-button>
        </div>
        <b-popover
          :target="`tooltip-collapse-${indexTab}-${index}-2`"
          triggers="hover"
          placement="right"
        >
          <template v-slot:default
            >{{ $t("transferAmount") }} = {{ $t("salesAfterDiscount") }} -
            {{ $t("TotalAfterDeductionExpenses") }} ({{
              $t("VATIncluded")
            }})</template
          >
        </b-popover>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <label
          >฿ {{ item.orderResultDisplay.grandTotal | numeral("0,0.00") }}</label
        >
      </b-col>
    </b-row>
    <b-row class="mx-3 pb-3 collapse-statement-label-custom">
      <b-col cols="8" class="d-flex">
        <label class="mb-1">WHT (Brand Seller)</label>
        <div :id="`tooltip-collapse-${indexTab}-${index}-3`">
          <b-button
            size="sm"
            variant="link"
            v-b-tooltip.hover
            class="tootip-custom"
          >
            <font-awesome-icon icon="question-circle" title="View" />
          </b-button>
        </div>
        <b-popover
          :target="`tooltip-collapse-${indexTab}-${index}-3`"
          triggers="hover"
          placement="right"
        >
          <template v-slot:default>{{ $t("sellerGetfinFee") }} 3%</template>
        </b-popover>
      </b-col>
      <b-col cols="4" class="d-flex justify-content-end pl-0">
        <label>฿ {{ item.orderResultDisplay.whtGetfinSeller | numeral("0,0.00") }}</label>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TaxTooltip from "./Tooltip.vue";

export default {
  name: "PanelTab",
  components: {
    TaxTooltip,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
    index: {
      required: false,
      type: Number,
    },
    indexTab: {
      required: false,
      type: Number,
    },
    gotoTab: {
      required: false,
      type: Array,
    },
  },
  created: async function () {},
};
</script>
<style scoped>
.collapse-statement-label-custom {
  font-size: 16px;
  font-weight: 700;
}
::v-deep .tootip-custom {
    padding: 0 5px;
}
</style>
